import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { get_all_users } from '../../redux/actions/userAuthActions'
import Loader from '../../components/Loader'
import Pagination from '../../components/Pagination'
import { GrFormView } from 'react-icons/gr'
import { GET_ALL_USERS_RESET } from '../../redux/types'

const DashboardSubmissions = () => {
	const dispatch = useDispatch()

	const [selected, setSelected] = useState('')
	// const [tagged, setTagged] = useState("");
	// const [buildingType, setBuildingType] = useState("");
	// const [category, setCategory] = useState("");
	// const [points, setPoints] = useState("");
	const [keyword, setKeyword] = useState('')

	const pageNumber = new URLSearchParams(useLocation().search).get('page') || 1

	const categoryHead = ['S/N', 'User', 'Email', 'Phone Number', 'View']

	const getAllUsers = useSelector((state) => state.getAllUsers)
	const { loading, users } = getAllUsers

	let i = 0

	// const filterHandler = (e) => {
	// 	e.preventDefault();
	// 	dispatch(
	// 		get_locations(
	// 			pageNumber,
	// 			selected,
	// 			tagged,
	// 			points,
	// 			buildingType,
	// 			category,
	// 			keyword
	// 		)
	// 	);
	// };

	// const searchHandler = (e) => {
	// 	e.preventDefault();
	// 	dispatch(
	// 		get_locations(
	// 			pageNumber,
	// 			selected,
	// 			tagged,
	// 			points,
	// 			buildingType,
	// 			category,
	// 			keyword
	// 		)
	// 	);
	// };

	useEffect(() => {
		dispatch(
			get_all_users(
				pageNumber
				// selected
				// keyword
			)
		)

		return () => {
			dispatch({ type: GET_ALL_USERS_RESET })
		}
	}, [dispatch, pageNumber, selected])

	return (
		<>
			<div className='user_dashboard'>
				<div className='row justify-content-center mb-5'>
					<div className='col-md-11 mt-5'>
						{/* <div className="row mb-3">
							<div className="col-md-6"></div>
							<div className="col-md-6">
								<input
									type="input"
									placeholder="search"
									className="site-form"
									onChange={(e) => setKeyword(e.target.value)}
									onInput={searchHandler}
								/>
							</div>
						</div> */}
						{/* <div className="filter-div">
							<div className="row ">
								<div className="col-md-3 col-sm-4 col-6">
									<select
										value={selected}
										onChange={(e) =>
											setSelected(e.target.value)
										}
										className="form-select mb-3"
									>
										<option value="">Status</option>
										<option value=''>All</option>
										<option value="active">Active</option>
										<option value="pending">Pending</option>
										<option value="deleted">Deleted</option>
									</select>
								</div>
							</div>
						</div> */}

						{loading ? (
							<Loader />
						) : (
							<>
								{users && users.users.length > 0 ? (
									<div className='table-responsive shadow-sm'>
										<table className='table table-bordered table-striped'>
											<thead className=''>
												<tr>
													{categoryHead.map((cate, i) => (
														<th key={i}>{cate}</th>
													))}
												</tr>
											</thead>
											<tbody>
												{users.users.map((l, i) => (
													<tr key={l._id}>
														<td>{(users.meta.page - 1) * 10 + i + 1}</td>
														<td>
															{l.firstName} {l.lastName}
														</td>
														<td>{l.email}</td>
														<td>{l.phoneNumber}</td>
														<td>
															<Link to={`/admin/dashboard/users/${l.fullName}`}>
																<GrFormView size={20} />
															</Link>
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								) : (
									<div className='card'>
										<div className='card-body'>
											<p className='nothing'>No Users found</p>
										</div>
									</div>
								)}
								{users && users.meta && users.meta.pages > 1 && (
									<>
										<Pagination
											currentPage={Number(users.meta.page)}
											totalCount={Number(users.meta.total)}
											pageSize={10}
											pathname={'/admin/dashboard/users'}
										/>
									</>
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</>
	)
}

export default DashboardSubmissions
